<template>
	<div id="index">
		<div class="header_fixed" ref="headerFixed">
			<topheader class="topheader"></topheader>
			<topsearch class="topsearch" v-if="fixedkey == false"></topsearch>
		</div>
		<flxedsearch :class="{v_fixed:fixedkey}" v-if="fixedkey"></flxedsearch>
		<topnav :errlist="navlist" :toshow="true"></topnav>
		<!-- <keep-alive include="seemore"> -->
		<router-view></router-view>
		<!-- 	<keep-alive>
		      <router-view v-if="$route.meta.keepAlive"></router-view>
		    </keep-alive>
		    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
		<!-- </keep-alive> -->

		<footerhtml></footerhtml>
		<copyright></copyright>
		<rightflxed></rightflxed>
	</div>
</template>
<script>
	import topheader from '@/components/topheader'
	import topsearch from '@/components/topsearch'
	import flxedsearch from '@/components/flxedsearch'
	import topnav from '@/components/topnav'
	import footerhtml from '@/components/footer'
	import copyright from '@/components/copyright'
	import rightflxed from '@/components/rightflxed'
	import qs from "qs";
	export default {
		name: 'index',
		data() {
			return {
				navlist: [],
				fixedkey: false,
				shopData: {}, //辨别身份id

			}
		},
		components: {
			topheader,
			topsearch,
			topnav,
			flxedsearch,
			footerhtml,
			copyright,
			rightflxed
		},

		created() {
			let that = this;
			console.log(that.$storage.get('user_data'))
			if(that.$storage.get('user_data') != null) {
				that.shopData['userrole'] = that.$storage.get('user_data').rank_id
				that.loginFn();
				that.getFriend();
				that.updateFn();
			} else {
				that.$alert("亲，请先登录哦。", "系统提示", {
						confirmButtonText: "前往登录",
						//					cancelButtonText: "我再想想",
						showClose: false,
						center: true,
						customClass: "alertboxq",
						confirmButtonClass: "alertboxqbtn1"
					})
					.then((res) => {
						that.$router.push({
							path: "/login",
							query: {}
						});
					})
					.catch((error) => {

					});
				that.shopData['userrole'] = 1
			}

			// that.shangpinFn();
			
		},
		methods: {
			//获取个人中心基础数据
			updateFn() {
				let that = this;
				axios({
						method: "post",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
						},
						url: that.$publicUrl.http1 + that.$publicUrl.personalupdates,
						data: qs.stringify(that.$storage.get('user_data'))
					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							console.log(data.data)
							that.$storage.set("user_data", data.data);
							
							
						} else {
							that.personalData = {};
							that.$message({
								message: data.msg,
								type: "warning"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//获取方法
			loginFn() {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.loginfobdlogin,
						data: qs.stringify({
							user_id: that.$storage.get('user_data').user_id,

						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {
							if(data.data == 1) {
								that.$confirm("为方便一键登录等操作，建议您先前往绑定微信哦~", "绑定微信", {
										confirmButtonText: "前往绑定",
										cancelButtonText: "我再想想",
										showClose: false,
										center: true,
										customClass: "alertboxq",
										confirmButtonClass: "alertboxqbtn1"
									})
									.then((res) => {
										that.$router.push({
											path: "/personalWechart",
											query: {}
										});
									})
									.catch((error) => {

									});
							}
						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getFriend() {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.categorylist,
						data: qs.stringify(that.shopData),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {

							that.navlist = data.data;

						} else {
							that.personalData = {};
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},

			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				//				console.log(this.$refs.headerFixed.offsetHeight)
				//				let height = this.$refs.headerFixed.offsetHeight;
				if(scrollTop >= 190) {
					this.fixedkey = true
				} else {
					this.fixedkey = false

				}
			},

		},
		mounted() {

			window.addEventListener('scroll', this.handleScroll)
		},
	}
</script>
<style scoped>
	.header_fixed {
		height: 190px;
	}
</style>